import UnregisteredRecordContainer from '../../containers/unregisteredRecord/unregisteredRecordContainer';

export default function UnregisteredRecord() {
  return <UnregisteredRecordContainer />;
}
